import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.89999962,3.57142857 C8.9184568,3.57142857 8.12508541,2.7755102 8.12508541,1.79081633 C8.12508541,0.806122449 8.9184568,0.0102040816 9.89999962,0.0102040816 C10.8815424,0.0102040816 11.6749138,0.806122449 11.6749138,1.79081633 C11.6749138,2.7755102 10.8815424,3.57142857 9.89999962,3.57142857"
});

var SvgGraphql = function SvgGraphql(props) {
  return _ref;
};

export default SvgGraphql;